import { render } from "./titulo.vue?vue&type=template&id=d3d35374"
import script from "./titulo.vue?vue&type=script&async=true&lang=js"
export * from "./titulo.vue?vue&type=script&async=true&lang=js"

import exportComponent from "E:\\Projetos Web\\web-vida-vascular\\web-vidavascularjf-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__